import { useSuspenseQuery } from "@tanstack/react-query";
import { getProjectPHPSettings } from "../openapi/api-client.ts";
import { LoadProjectPHPSettingsError } from "../errors/LoadProjectPHPSettingsError.ts";

export const useProjectPHPSettings = (projectId?: string) =>
  useSuspenseQuery({
    queryKey: ["projectPHPSettings", { projectId }],
    queryFn: async () => {
      if (!projectId) {
        throw new Error("project id not set");
      }

      const response = await getProjectPHPSettings({
        path: { projectId },
      });

      if (!response.data) {
        throw new LoadProjectPHPSettingsError(
          `error while fetching project php settings: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
